import React, { useEffect } from "react";
import PrintExport from "../../../components/common/ui/Export/PrintExport";
import { history } from "../../../_helpers";
import Button from "../../../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { staffRequestAction } from "../../../_store";
import { useLocation } from "react-router-dom";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import { handleReviewRequestFormNavigation } from "./ReviewRequestFormNavigator";

function FormHeader({
  handlePrints,
  list,
  showFeedBack,
  handleFeedBack,
  source,
  navigateBack,
  errorMessage,
  setErrorMessage,
  setPublicDefenderID,
  setShowRejectReasonTextInput,
  requestFormSubmitted,
  setRequestFormSubmitted,
  setFormType,
  requestFormTypePopup,
  setRequestFormTypePopUp,
  // formName = "",
}) {
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    requestReview,
    staffRequestList,
    staffRequestSearchList,
    indexValue,
  } = useSelector((x) => x?.staffRequest);

  const { user } = useSelector((x) => x.auth);
  const managementUserID = user?.ManagementUserID;

  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);

  const sourceFrom = location?.state ? location?.state?.sourceFrom : "";

  useEffect(() => {
    if (
      !requestReview &&
      list &&
      Object?.keys(list)?.length === 0 &&
      source &&
      source !== "privateConversation"
    ) {
      // history?.navigate("StaffRequestList");
    }
  }, []);

  useEffect(() => {
    if (!requestReview && list?.DataList?.length > 0) {
      history?.navigate("StaffRequestList");
    }
  }, [requestReview, list]);

  const handlePrevNext = async (direction) => {
    //clear error message when navigate
    setErrorMessage?.({});
    //clear staff request form value when navigate
    await Promise.all([
      dispatch(staffRequestAction?.resetRequestFormInfoPayloadData()),
      dispatch(staffRequestAction?.resetPublicDefenderFormPayload()),
      dispatch(staffRequestAction?.resetPublicDefenderRequestFormPayload()),
    ]).then((x) => {
      setPublicDefenderID?.(0);
      setShowRejectReasonTextInput?.(false);
      const payload = { ...requestFormTypePopup };
      payload.newRequestFormTypeId = 0;
      setRequestFormTypePopUp?.(payload);
      setFormType?.(1);
      if (
        requestFormSubmitted !== undefined &&
        requestFormSubmitted !== null &&
        requestFormSubmitted === true &&
        requestReview
      ) {
        const searchData = { ...staffRequestSearchList };
        searchData.PageNo = 1;
        searchData.RowCountPerPage = staffRequestList?.TotalRecordCount;
        searchData.FacilityID = facilityCode;
        searchData.ManagementUserID = managementUserID;
        dispatch(staffRequestAction?.LoadRequestReviewAllList(searchData))
          .then((result) => {
            if (result?.payload) {
              const data = result?.payload;
              handleReviewRequestFormNavigation(
                direction,
                data,
                direction === "next" ? indexValue : indexValue - 1,
                history,
                sourceFrom,
                dispatch
              );
            }
          })
          .catch((err) => {
            showToastNotification("Something went wrong", "error");
          });

        setRequestFormSubmitted?.(false);
        return;
      }
    })

    // if (direction === "next" && list?.DataList?.length === indexValue + 1)
    //   return;

    // if (direction === "prev" && indexValue === 0) return;
    const index = indexValue;
    dispatch(staffRequestAction?.updateReviewStatus(true));
    if (!requestReview) return;
    var updateIndex = direction === "next" ? index + 1 : index - 1;
    if (direction === "prev" && (indexValue === 0 || indexValue <= 0)) {
      updateIndex = list?.DataList?.length - 1;
    }
    if (direction === "next" && list?.DataList?.length === indexValue + 1) {
      updateIndex = 0;
    }
    dispatch(staffRequestAction?.updateIndexValue(updateIndex));
    const formType = list?.DataList[updateIndex]?.RequestFormType;
    const row = list?.DataList[updateIndex];
    switch (formType) {
      case 1:
        history.navigate("StaffRequestList/VisitorRequestForm", {
          state: {
            formID: row?.RequestFormTypeID,
            formDetails: list,
            sourceFrom: source,
            RequestFormType: row.RequestFormType,
          },
        });
        break;

      case 60:
        history.navigate("StaffRequestList/LegalResearchRequest", {
          state: {
            formID: row?.RequestFormTypeID,
            formDetails: list,
            sourceFrom: source,
            RequestFormType: row.RequestFormType,
          },
        });
        break;

      case 2:
        history.navigate("StaffRequestList/RequestRemedyForm", {
          state: {
            formID: row?.RequestFormTypeID,
            formDetails: list,
            sourceFrom: source,
            RequestFormType: row.RequestFormType,
          },
        });
        break;
      case 53:
        history.navigate("StaffRequestList/PublicDefenderForm", {
          state: {
            formID: row?.RequestFormTypeID,
            formDetails: list,
          },
        });
        break;

      case 62:
        history.navigate("StaffRequestList/PublicDefenderFormCrisp", {
          state: {
            formID: row?.RequestFormTypeID,
            formDetails: list,
          },
        });
        break;

      case 63:
        history.navigate("StaffRequestList/PublicDefenderServiceForm", {
          state: {
            formID: row?.RequestFormTypeID,
            formDetails: list,
          },
        });
        break;

      case 59:
        history.navigate("StaffRequestList/PublicDefenderFormCrisp", {
          state: {
            formID: row?.RequestFormTypeID,
            formDetails: list,
          },
        });
        break;

      default:
        break;
    }
    if (
      formType >= 3 &&
      formType !== 53 &&
      formType !== 59 &&
      formType !== 63 &&
      formType !== 60 &&
      formType !== 62
    ) {
      history.navigate("StaffRequestList/RequestFormInfo", {
        state: {
          formID: row?.RequestFormTypeID,
          RequestFormType: row?.RequestFormType,
          oldRequestFormTitle: row?.RequestFormTitle,
          InmateID: row?.InmateID,
          InmateResidentId: row?.InmateResidentId,
          formDetails: list,
        },
      });
    }
  };
  return (
    <div className="d-flex flex-wrap justify-content-end gap-3 mb-3">
      {requestReview &&
        list?.DataList?.length > 1 &&
        (indexValue !== 0 || list?.DataList?.length !== indexValue + 1) && (
          <div className=" d-flex flex-wrap justify-content-center align-items-center gap-3">
            <i
              className={`fas fa-arrow-alt-circle-left fs-2 cursor-pointer ${indexValue === 0 ? "" : ""
                }`}
              onClick={() => handlePrevNext("prev")}
              title="prev"
            ></i>

            <i
              className={`fas fa-arrow-alt-circle-right fs-2 cursor-pointer ${list?.DataList?.length === indexValue + 1 ? "" : ""
                }`}
              onClick={() => handlePrevNext("next")}
              title="next"
            />
          </div>
        )}
      <PrintExport
        handlePrintShow={() => {
          handlePrints();
        }}
      />
      {showFeedBack && (
        <div
          data-bs-toggle="modal"
          data-bs-target="#public-defender-crisp-feedback"
        // onClick={() => handlePCRCount(row)}
        >
          <Button
            label="Feedback"
            type="button"
            icon={"fa-solid fa-comment"}
            status="success"
            onClick={() => handleFeedBack()}
          />
        </div>
      )}
      <Button
        label="Back"
        type="button"
        icon={"fa-solid fa-angle-left"}
        status="primary"
        onClick={() => {
          dispatch(staffRequestAction?.resetPublicDefenderRequestFormPayload());
          dispatch(staffRequestAction?.resetPublicDefenderFormPayload());
          dispatch(staffRequestAction.resetRequestFormInfoPayloadData());
          dispatch(staffRequestAction.updateReviewStatus(false));
          // dispatch(staffRequestAction?.resetStaffRequestSearcList());
          // if (formName === "Request Form") {
          //   const searchList = {
          //     ...staffRequestSearchList,
          //     PageNo: 1,
          //     RowCountPerPage: 10,
          //     FacilityID: facilityCode,
          //   };
          //   dispatch(staffRequestAction?.setStaffRequestSearchList(searchList));
          // }
          history?.navigate(
            navigateBack ? navigateBack : "/Admin/StaffRequestList"
          );
        }}
      />
    </div>
  );
}

export default React.memo(FormHeader);
